export default {
  messages: (state) => state.Messages || {},
  loopMessages: (state) => state.loop || {},
  breakTheWallBalls: (state) => state.BreakTheWallBalls || [],
  polls: (state) => state.Polls || {},
  pollsAnswers: (state) => state.Answers || {},
  words: (state) => state.words || {},
  currentRanking: (state) => state.lastKnownRanking || [],
};
